module.exports = __webpack_public_path__ + "static/media/F2.6644dc89.jpg";